import styled from "styled-components";

import { Container } from "../../styles/Container";

export const Wrapper = styled.div`
  margin: 3rem auto;

  ${Container}
`;

export const Content = styled.div`
  width: 100%;
  padding: 1rem 0;

  h1 {
    font-size: 3rem;
  }
  section {
    /* display: flex;
    justify-content: space-between; */
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(4,1fr);

    @media (max-width: 992px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 400px) {
      grid-template-columns: repeat(1, 1fr);

      ul {
        margin-left: 2rem;
      }
    }

    ul {
      list-style-type: initial;
      list-style-position: inside;
      li {
        margin: 1rem 0;
      }
    }
  }
`;
